import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@ngneat/transloco';
import { TranslocoMarkupModule } from 'ngx-transloco-markup';
import { ButtonModule } from '../button';
import { CommonWordingModule } from '../common-wording';
import { icoCross, icoCrossCircleDuo, icoError, icoInfoDuo, IconsModule, icoTickCircleDuo, icoWarningDuo } from '../icons';
import { LinkModule } from '../link';
import { LoadingIndicatorModule } from '../loading';
import { AsActionFilterPipe } from './as-action-filter.pipe';
import { AsBootstrapClassPipe } from './as-bootstrap-class.pipe';
import { ErrorOutletComponent } from './error-outlet/error-outlet.component';
import { NotificationMessageComponent } from './notification-message/notification-message.component';
import { NotificationOutletComponent } from './notification-outlet/notification-outlet.component';

@NgModule({
  declarations: [AsActionFilterPipe, AsBootstrapClassPipe, ErrorOutletComponent, NotificationMessageComponent, NotificationOutletComponent],
  imports: [
    ButtonModule,
    CommonModule,
    CommonWordingModule,
    IconsModule.withIcons(icoCross, icoCrossCircleDuo, icoInfoDuo, icoError, icoTickCircleDuo, icoWarningDuo),
    LinkModule,
    LoadingIndicatorModule,
    RouterModule,
    TranslocoMarkupModule,
    TranslocoModule
  ],
  exports: [ErrorOutletComponent, NotificationOutletComponent]
})
export class NotificationModule {}
